import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import AppUtils from '../../../utils/AppUtils'
import AppConstants from '../../../utils/AppConstants'
import MaintenanceForm from '../../../components/forms/MaintenanceForm'
import Popup from '../../../components/elements/Popup'

import Types from '../../../actions/Types'
import PostAction from '../../../actions/maintenances/PostAction'
import ListProductsAction from '../../../actions/products/ListAction'
import ClearErrorAction from '../../../actions/app/ClearErrorAction'

class CreateMaintenancePopup extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      submit: null
    }

    // Bind events
    this.submit = this.submit.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  componentDidMount() {
    this.props.fetchProducts()
  }

  componentDidUpdate(prevProps, prevState) {
    // When successful, close popup
    if (
      prevProps.isSaving
      &&
      !this.props.isSaving
      &&
      !this.props.error
    ) {
      AppUtils.setStatus(AppConstants.STATUS.TYPE.SUCCESS, 'Maintenance ajoutée.')
      this.props.onClose(true)
    }
  }

  submit() {
    if (_.isFunction(this.state.submit)) {
      this.state.submit()
    }
  }

  onSubmit(data) {
    this.props.post(data)
  }

  render() {
    return (
      <Popup
        header='Créer une maintenance'
        body={
          <MaintenanceForm
            product={this.props.product || undefined}
            data={undefined}
            onSubmit={this.onSubmit}
            onClearError={this.props.clearError}
            isLoading={false}
            isSaving={this.props.isSaving}
            registerSubmit={(submit) => { this.setState({ submit })}}
            error={this.props.error}
            productsList={this.props.productsList}
            productsIsFetching={this.props.productsIsFetching}
          />
        }
        footer={[
          {
            type: Popup.BUTTONTYPE.CLOSE,
            title: 'Annuler',
            color: 'red',
            icon: 'close',
            basic: true,
            onClick: () => this.props.onClose(false)
          },
          {
            type: Popup.BUTTONTYPE.SUBMIT,
            title: 'Créer',
            color: 'green',
            icon: 'checkmark',
            onClick: this.submit
          }
        ]}
        isSaving={this.props.isSaving}
      />
    )
  }
}

CreateMaintenancePopup.propTypes = {
  // Properties
  product: PropTypes.number,
  onClose: PropTypes.func.isRequired,

  // Redux State
  isSaving: PropTypes.bool.isRequired,
  error: PropTypes.object,
  productsList: PropTypes.array,
  productsIsFetching: PropTypes.bool.isRequired,

  // Redux Actions
  post: PropTypes.func.isRequired,
  fetchProducts: PropTypes.func.isRequired,
  clearError: PropTypes.func.isRequired
}

export default connect(
  (state) => ({
    isSaving: state.entities.maintenances.post.isFetching,
    error: state.entities.maintenances.post.error,
    productsList: state.entities.products.list.data,
    productsIsFetching: state.entities.products.list.isFetching
  }),
  (dispatch) => ({
    post: (data) => (dispatch(PostAction({ data }))),
    fetchProducts: () => (dispatch(ListProductsAction({}))),
    clearError: () => (dispatch(ClearErrorAction(Types.MAINTENANCES.POST)))
  })
)(CreateMaintenancePopup)



// WEBPACK FOOTER //
// ./src/containers/popups/maintenances/CreateMaintenancePopup.js